import Swiper from 'swiper';
import { Navigation, Controller, EffectFade } from 'swiper/modules';

export default {
	init() {
		var layouts = document.querySelectorAll('.layout.testimonials');
		if (!layouts.length) return;

		layouts.forEach(function(layout) {
			var mediaEl = layout.querySelector('.testimonials-slider');
			var textEl  = layout.querySelector('.testimonials-text-slider');
			if (!mediaEl && !textEl) return;

			var prevEl = layout.querySelector('.testimonials-prev');
			var nextEl = layout.querySelector('.testimonials-next');
			var hasNav = !!(prevEl && nextEl);

			// Navigation lives on the media swiper when present, otherwise the text
			// swiper — the controller keeps the other in sync either way.
			var navOnMedia = !!mediaEl;

			function buildConfig(withNav) {
				var cfg = {
					modules:        [Controller, EffectFade],
					effect:         'fade',
					fadeEffect:     { crossFade: true },
					slidesPerView:  1,
					loop:           false,
					speed:          400,
					allowTouchMove: false,
				};
				if (withNav && hasNav) {
					cfg.modules = [Controller, EffectFade, Navigation];
					cfg.navigation = { prevEl: prevEl, nextEl: nextEl };
				}
				return cfg;
			}

			var textSwiper = null;
			if (textEl) {
				var textCfg = buildConfig(!navOnMedia);
				textCfg.autoHeight = true; // handles variable quote lengths
				textSwiper = new Swiper(textEl, textCfg);
			}

			var mediaSwiper = null;
			if (mediaEl) {
				mediaSwiper = new Swiper(mediaEl, buildConfig(true));
			}

			if (mediaSwiper && textSwiper) {
				mediaSwiper.controller.control = textSwiper;
				textSwiper.controller.control  = mediaSwiper;
			}
		});
	},
};
